import { forwardRef, type HTMLAttributes } from 'react';
import MaterialTileIcon from '@assets/img/dice-game/materials.svg?react';
import cn from 'classnames';

import { Tile } from '../Tile/Tile';
import { TilesBg } from '../TilesBg/TilesBg';

interface MaterialTileProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
}

const MaterialTile = forwardRef<HTMLDivElement, MaterialTileProps>(
  (props, ref) => {
    return (
      <Tile
        ref={ref}
        {...props}
        variant={props.isActive ? 'dark' : 'grey'}
        className={cn(props.className, 'flex items-center justify-center')}
      >
        <MaterialTileIcon className="size-[90%] relative z-[3]" />
        {props.isActive && <TilesBg variant="green-active" />}
      </Tile>
    );
  },
);

export { MaterialTile };
